import { privateRequest, type ApiResponse } from "../axios";
import type { CustomField } from "./customField";

const ENDPOINTS = {
  CUSTOMER_CONFIGURATION_FIELDS: "api/CustomerConfigurationFields",
  CUSTOMER_CONFIGURATION_CUSTOM_FIELDS: "api/CustomerConfigurationCustomFields",
  CUSTOMER_CONFIGURATION_FIELD_SETTING: "api/CustomerConfigurationFieldSetting",
  UPDATE_CUSTOMER_CONFIGURATION_FIELD_SETTING: "api/CustomerConfigurationFieldSetting",
};

export const formatDate = (input: string) => {
  if (!input) return "";

  const parts = input.split(" ");
  if (parts.length < 1) return "";

  const datePart = parts[0];
  if (!datePart) return "";

  const [month, day, year] = datePart.split("-");
  if (!month || !day || !year) return "";

  const d = new Date(Number(year), Number(month) - 1, Number(day));

  return d.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "long",
    year: "numeric",
  });
};

const fetchCustomerConfigurationFields = async (): Promise<any> => {
  const res = await privateRequest.get(ENDPOINTS.CUSTOMER_CONFIGURATION_FIELDS);
  return res.data;
};

const addCustomerConfigurationField = async (data: CustomField) => {
  const response = await privateRequest.post(
    ENDPOINTS.CUSTOMER_CONFIGURATION_CUSTOM_FIELDS,
    data,
  );
  return response.data;
};

const updateCustomerConfigurationCustomFields = async (
  payload: any,
): Promise<ApiResponse<any>> => {
  const res = await privateRequest.post<ApiResponse<any>>(
    `${ENDPOINTS.CUSTOMER_CONFIGURATION_CUSTOM_FIELDS}`,
    payload,
  );
  return res.data;
};

const getCustomerConfigurationFieldSetting = async (): Promise<any> => {
  const res = await privateRequest.get(ENDPOINTS.CUSTOMER_CONFIGURATION_FIELD_SETTING);
  return res.data;
}

const updateCustomerConfigurationFieldSetting = async (payload: any): Promise<any> => {
  const res = await privateRequest.put(ENDPOINTS.UPDATE_CUSTOMER_CONFIGURATION_FIELD_SETTING, payload);
  return res.data;
};

const CrmConfigurationService = {
  fetchCustomerConfigurationFields,
  updateCustomerConfigurationCustomFields,
  addCustomerConfigurationField,
  getCustomerConfigurationFieldSetting,
  updateCustomerConfigurationFieldSetting,
};
export default CrmConfigurationService;
